import { useState } from "react";
import axios from "axios";
import { SiteHeader } from "../../components/site/SiteHeader";
import { SiteFooter } from "../../components/site/SiteFooter";
import { openRazorpayCheckout } from "../../lib/razorpay";

const API = process.env.REACT_APP_BACKEND_URL;
const L = "block text-xs tracking-[0.16em] uppercase text-slate-400 mb-2";
const IN = "w-full bg-white/[0.04] border border-white/15 focus:border-[#C9A84C] outline-none px-4 py-3 text-[15px] text-white placeholder:text-slate-600 transition-colors";

export default function PaymentTest() {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [f, setF] = useState({ name: "", email: "", phone: "", amount: "" });
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const start = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/api/payments/initiate`, {
        name: f.name, email: f.email, phone: f.phone, product: "Sandbox Gateway Test",
        amount: parseFloat(f.amount) || 0, gateway: "razorpay",
      });
      if (data.razorpay) {
        await openRazorpayCheckout({
          API: process.env.REACT_APP_BACKEND_URL, txnid: data.txnid,
          onPaid: () => window.location.assign(`/payment/success?txnid=${data.txnid}`),
          onError: (m) => { setErr(m); setBusy(false); },
        });
        return;
      }
      setErr("Gateway did not return a Razorpay checkout. Check the Razorpay settings in admin.");
      setBusy(false);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Could not start the test payment.");
      setBusy(false);
    }
  };

  return (
    <div className="font-publicsans bg-nx-navy text-slate-200 antialiased min-h-screen flex flex-col" data-testid="payment-test-page">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-5 py-24">
        <div className="w-full max-w-md border border-amber-500/40 bg-[#0A1628] p-8 sm:p-10">
          <p className="text-[10px] tracking-[0.28em] uppercase text-amber-300 border border-amber-500/40 inline-block px-3 py-1.5" data-testid="payment-test-banner">Sandbox Testing — No Real Money</p>
          <h1 className="font-marcellus text-2xl text-white mt-4">Razorpay Gateway Test</h1>
          <p className="text-xs text-slate-500 mt-3 leading-relaxed">
            Internal page for verifying the Razorpay sandbox with test cards. Test payments are tagged and never counted in revenue. Not linked anywhere on the site.
          </p>
          <form onSubmit={start} className="mt-6 space-y-4">
            <div><label className={L} htmlFor="pt-name">Name</label><input id="pt-name" data-testid="pt-name" className={IN} value={f.name} onChange={set("name")} required /></div>
            <div><label className={L} htmlFor="pt-email">Email</label><input id="pt-email" data-testid="pt-email" type="email" className={IN} value={f.email} onChange={set("email")} required /></div>
            <div><label className={L} htmlFor="pt-phone">Phone</label><input id="pt-phone" data-testid="pt-phone" type="tel" className={IN} value={f.phone} onChange={set("phone")} required /></div>
            <div><label className={L} htmlFor="pt-amount">Amount (₹)</label><input id="pt-amount" data-testid="pt-amount" type="number" min="1" step="0.01" className={IN} value={f.amount} onChange={set("amount")} required /></div>
            {err && <p className="text-[12px] text-red-400" data-testid="pt-error">{err}</p>}
            <button type="submit" disabled={busy} className="w-full bg-[#C9A84C] hover:bg-[#dbb95c] disabled:opacity-60 text-[#0A1628] font-bold tracking-wide text-base px-6 py-4 transition-colors" data-testid="pt-submit">
              {busy ? "Opening Razorpay Sandbox…" : "Start Sandbox Payment"}
            </button>
          </form>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
